export function isActiveNode(editor, name) {
  const sel = editor.state.selection
  if (sel.node) return sel.node.type.name === name
  return editor.isActive(name)
}

function getExtension(editor, extensionName) {
  if (!editor) return null

  return editor.extensionManager.extensions.find(
    ext => ext.name === extensionName
  ) || null
}

export function hasExtension(editor, extensionName) {
  return Boolean(getExtension(editor, extensionName))
}

export function isCustomExtension(editor, extensionName, markerKey) {
  const ext = getExtension(editor, extensionName)
  if (!ext) return false

  return Boolean(
    ext.storage?.[markerKey] ??
    ext.options?.[markerKey]
  )
}

export const hasLink = editor => hasExtension(editor, 'link')
export const hasCustomLink = editor =>
  isCustomExtension(editor, 'link', '__isImperiaLink')

export const hasImage = editor => hasExtension(editor, 'image')
export const hasCustomImage = editor =>
  isCustomExtension(editor, 'image', '__isImperiaImage')